import React, { useEffect, useRef } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import {
	ConfigMode, IModelConfig, ISlider, Settings,
} from '../../../aIChatPlaygroundInterface';
import { Container, i18n } from '../../../../../symphony';
import s from './AIChatPlaygroundSettingSlider.scss';
import { aIChatPlaygroundContext } from '../../../aIChatPlaygroundConstants';
import { AIChatPlaygroundService } from '../../../services/AIChatPlaygroundService';

interface IAIChatPlaygroundSettingSliderProps {
	setting: IModelConfig
}

export const AIChatPlaygroundSettingSlider = ({ setting }: IAIChatPlaygroundSettingSliderProps) => {
	useStyles(s);
	const { updateSettings } = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundService);
	const aiChatSettings = Container.take('global', 'ai-chat-settings') as Settings;
	const sliderData: ISlider = aiChatSettings?.[setting.key];
	const inputRef = useRef<HTMLInputElement>(null);
	const setInputValue = (v: number) => {
		const inputValue = ((v - sliderData.minValue) / (sliderData.maxValue - sliderData.minValue)) * 100;
		inputRef.current.style.background = `linear-gradient(to right, #485E78 0%, #485E78 ${inputValue}%, #B6BFC9 ${inputValue}%, #B6BFC9 100%)`;
		updateSettings(setting.key, v.toString());
	};

	useEffect(() => {
		setInputValue(+setting.value);
	}, []);

	if (!sliderData) return null;

	return (
		<div className="ai-chat-playground-setting-slider">
			<div className="ai-chat-playground-setting-slider__label">
				<div className="ai-chat-playground-setting-slider__title">
					{i18n.t(sliderData.title)}
				</div>
				<div className="ai-chat-playground-setting-slider__value">
					{(+setting.value).toFixed(2)}
				</div>
			</div>
			<div className="ai-chat-playground-setting-slider__input-container">
				<input
					ref={inputRef}
					type="range"
					min={sliderData.minValue}
					max={sliderData.maxValue}
					step={sliderData.step}
					value={+setting.value}
					onChange={(e) => { setInputValue(+e.target.value); }}
					className="ai-chat-playground-setting-slider__input"
					disabled={setting.mode !== ConfigMode.Edit}
				/>
			</div>
		</div>
	);
};
